<template lang="html">
  <d-button-group class="buttons">
    <d-checkbox
      toggle
      @change="toggleSpam"
      :checked="lead.status == 'spam'"
      class="custom-toggle-sm mb-0"
    >
      Spam
    </d-checkbox>
  </d-button-group>
</template>

<script>
export default {
  name: 'lead-buttons',
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  methods: {
    toggleSpam() {
      this.$emit('toggleSpam', this.lead);
    },
  },
};
</script>
